module.exports = __webpack_public_path__ + "img/selected0-min.afe9937d.png";